import React, { useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import AllStrageRules from '../strage/AllStrageRules'
import Checkbox from '@mui/material/Checkbox';
import { Height } from '../util/ScreenHeight'
import ListItemText from '@mui/material/ListItemText';
import FormHelperText from '@mui/material/FormHelperText';
import AlertD from '../util/AlertD';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
            // width: 250,
        },
    },
};

export default function RecSetting(props) {
    const [open, setOpen] = React.useState(false);
    const [nowRows, setNowRows] = React.useState(localStorage.getItem('sr_search_rules') != null ? JSON.parse(localStorage.getItem('sr_search_rules')) : [])
    const [showAlert, setShowAlert] = React.useState(false);
    const [alertMsg, setAlertMsg] = React.useState(null);
    const [pr, setPR] = React.useState("99");
    const [totalMoney, setTotalMoney] = React.useState("10");
    const [singleMoney, setSingleMoney] = React.useState("50");
    const [period, setPeriod] = React.useState("365");
    const [intervala, setIntervala] = React.useState("30");

    const [tags, setTags] = React.useState([])
    const [personName, setPersonName] = React.useState([]);

    const handleChange1 = (event) => {
        const {
            target: { value },
        } = event;

        if (value.length > 6) {
            setAlertMsg("最多選擇六個比率")
            setShowAlert(true)
        } else {
            setPersonName(
                typeof value === 'string' ? value.split(',') : value,
            );
        }
    };


    const nameToId = () => {
        return tags.filter(t => personName.includes(t.name)).map(row => row.id)
    }

    const clearRules = () => {
        setNowRows([]);
    };


    const handleClose = () => {
        setOpen(false);
        if (props.close != null) props.close(false)
        // if(props.refresh != null) props.refresh()
    };

    const handleOKClose = () => {
        // localStorage.setItem("sr_backtest_rules", JSON.stringify(nameToId()))

        createBackTest()
    };

    const createBackTest = () => {
        let param = {
            req: {
                id: nameToId(),
                mscore: pr,
                maxc: totalMoney,
                price: singleMoney
            }
        }

        if (localStorage.getItem("rate_lic") != null) {
            param['lic'] = localStorage.getItem("rate_lic")
        }

        fetch("/sr/v1/snapshot/create", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(param)
        })
            .then(res => res.json())
            .then(
                result => {
                    if (result != null && result.status === 0) {
                        setOpen(false);
                        if (props.close != null) props.close(false)
                        if (props.refresh != null) props.refresh()
                    } else if (result != null && result.status === -1) {
                        setAlertMsg("序號錯誤，請檢查是否有輸入序號。")
                        setShowAlert(true)
                    } else {
                        setAlertMsg("新增失敗，請稍後再嘗試")
                        setShowAlert(true)
                    }
                }
            );
    }


    useEffect(() => {
        if (props.open) setOpen(true)
        else setOpen(false)
    }, [props.open]);


    const updateRule = (id, data, enabled) => {
        if (enabled) {
            const rules = nowRows.filter(item => item.id !== id);
            const finalRules = rules.concat(data)
            setNowRows(finalRules)
        } else {
            const rules = nowRows.filter(item => item.id !== id)
            setNowRows(rules)
        }
    };

    const fectchTags = () => {
        let u = "/sr/v1/app/setting"

        fetch(u, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
        })
            .then(res => res.json())
            .then(
                result => {
                    if (result != null) {
                        setTags(result)
                    }
                }
            );
    }

    useEffect(() => {
        fectchTags()
    }, []);

    return (
        <div>
                        {showAlert ? <AlertD desc={alertMsg} open={showAlert} close={setShowAlert}></AlertD> : null}
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={open}
                onClose={handleClose}
            >
                <DialogTitle id="alert-dialog-title">
                    {"新增快照"}
                    <Typography color="red" variant="caption" sx={{ fontWeight: 'normal', alignSelf: 'center', ml: 1 }}>VIP專屬</Typography>
                </DialogTitle>


                <DialogContent sx={{ pl: 0.5, pr: 0.5 }}>
                    <DialogContentText sx={{ml:2, mr: 2}}>快照會將當下篩選出的股票記錄下來，並且跟上－個快照比對，快速列出股票的增減部位，幫助判斷那些股票需要被賣出，那些股票是可以買進。</DialogContentText>
                    <Stack spacing={3} direction="column" sx={{ p: 2 }}>
                        <FormControl fullWidth sx={{}} focused required>
                            <InputLabel id="demo-simple-select-standard-label">比率</InputLabel>
                            <Select
                                label="比率"
                                labelId="demo-simple-select-standard-label"
                                size="medium"
                                id="demo-multiple-checkbox"
                                multiple
                                value={personName}
                                onChange={handleChange1}
                                // input={<OutlinedInput label="Tag" />}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={MenuProps}
                            >
                                {tags.map((row) => (
                                    <MenuItem key={row.id} value={row.name}>
                                        <Checkbox checked={personName.indexOf(row.name) > -1} />
                                        <ListItemText primary={row.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>用來計算綜合PR值</FormHelperText>
                        </FormControl>



                        <FormControl fullWidth required>
                            <InputLabel id="pr-label">綜合評比</InputLabel>
                            <Select
                                labelId="pr-label"
                                id="pr"
                                value={pr}
                                label="綜合評比"
                                onChange={e => setPR(e.target.value)}
                            >
                                <MenuItem value={'99'}>{'PR99以上'}</MenuItem>
                                <MenuItem value={'98'}>{'PR98以上'}</MenuItem>
                                <MenuItem value={'97'}>{'PR97以上'}</MenuItem>
                                <MenuItem value={'96'}>{'PR96以上'}</MenuItem>
                                <MenuItem value={'95'}>{'PR95以上'}</MenuItem>
                                <MenuItem value={'94'}>{'PR94以上'}</MenuItem>
                                <MenuItem value={'93'}>{'PR93以上'}</MenuItem>
                                <MenuItem value={'92'}>{'PR92以上'}</MenuItem>
                                <MenuItem value={'91'}>{'PR91以上'}</MenuItem>
                                <MenuItem value={'90'}>{'PR90以上'}</MenuItem>
                                <MenuItem value={'80'}>{'PR80以上'}</MenuItem>
                                <MenuItem value={'70'}>{'PR70以上'}</MenuItem>
                                <MenuItem value={'60'}>{'PR60以上'}</MenuItem>
                                <MenuItem value={'50'}>{'PR50以上'}</MenuItem>
                                <MenuItem value={'40'}>{'PR40以上'}</MenuItem>
                                <MenuItem value={'30'}>{'PR30以上'}</MenuItem>
                                <MenuItem value={'20'}>{'PR20以上'}</MenuItem>
                                <MenuItem value={'10'}>{'PR10以上'}</MenuItem>
                            </Select>
                            <FormHelperText></FormHelperText>
                        </FormControl>

                        <FormControl fullWidth required>
                            <InputLabel id="totalMoney-label">股票數量</InputLabel>
                            <Select
                                labelId="totalMoney-label"
                                id="totalMoney"
                                value={totalMoney}
                                label="股票數量"
                                onChange={e => setTotalMoney(e.target.value)}
                            >
                                <MenuItem value={'10'}>{'10支以下'}</MenuItem>
                                <MenuItem value={'20'}>{'20支以下'}</MenuItem>
                                <MenuItem value={'30'}>{'30支以下'}</MenuItem>
                                <MenuItem value={'40'}>{'40支以下'}</MenuItem>
                                <MenuItem value={'50'}>{'50支以下'}</MenuItem>
                            </Select>
                            <FormHelperText>最多持有幾支股票</FormHelperText>
                        </FormControl>

                        <FormControl fullWidth required>
                            <InputLabel id="single-money-label">股價</InputLabel>
                            <Select
                                labelId="single-money-label"
                                id="single-money"
                                value={singleMoney}
                                label="股價"
                                onChange={e => setSingleMoney(e.target.value)}
                            >
                                <MenuItem value={'10'}>{'10元以下'}</MenuItem>
                                <MenuItem value={'20'}>{'20元以下'}</MenuItem>
                                <MenuItem value={'30'}>{'30元以下'}</MenuItem>
                                <MenuItem value={'40'}>{'40元以下'}</MenuItem>
                                <MenuItem value={'50'}>{'50元以下'}</MenuItem>
                                <MenuItem value={'60'}>{'60元以下'}</MenuItem>
                                <MenuItem value={'70'}>{'70元以下'}</MenuItem>
                                <MenuItem value={'80'}>{'80元以下'}</MenuItem>
                                <MenuItem value={'90'}>{'90元以下'}</MenuItem>
                                <MenuItem value={'100'}>{'100元以下'}</MenuItem>
                                <MenuItem value={'200'}>{'200元以下'}</MenuItem>
                                <MenuItem value={'300'}>{'300元以下'}</MenuItem>
                                <MenuItem value={'400'}>{'400元以下'}</MenuItem>
                                <MenuItem value={'500'}>{'500元以下'}</MenuItem>
                                <MenuItem value={'600'}>{'600元以下'}</MenuItem>
                                <MenuItem value={'700'}>{'700元以下'}</MenuItem>
                                <MenuItem value={'800'}>{'800元以下'}</MenuItem>
                                <MenuItem value={'900'}>{'900元以下'}</MenuItem>
                                <MenuItem value={'1000'}>{'1000元以下'}</MenuItem>
                                <MenuItem value={'2000'}>{'2000元以下'}</MenuItem>
                                <MenuItem value={'3000'}>{'3000元以下'}</MenuItem>
                                <MenuItem value={'4000'}>{'4000元以下'}</MenuItem>
                                <MenuItem value={'5000'}>{'5000元以下'}</MenuItem>
                            </Select>
                            <FormHelperText>股價要低於多少才買進</FormHelperText>
                        </FormControl>


                    </Stack>
                    {/* 
                    <Divider sx={{ m: 2 }}>
                        <Chip label="股票設定" />
                    </Divider>
                    <AllStrageRules updateRule={updateRule} rows={nowRows} /> */}

                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={clearRules}>清除規則</Button> */}
                    <Button disableElevation variant='contained' onClick={handleClose}>取消</Button>
                    {/* disabled={localStorage.getItem("noad") != "1"} */}
                    <Button disabled={localStorage.getItem("noad") != "1"} disableElevation variant='contained' onClick={handleOKClose} autoFocus>
                        確定
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
